import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { StatusBadge, LoadingSpinner, EmptyState } from '../../components/UI';
import { format } from 'date-fns';

export default function MyApplications() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  const load = () => {
    setLoading(true);
    api.get('/applications/my').then(r => setApps(r.applications || [])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const filtered = filter === 'all' ? apps : apps.filter(a => a.status === filter || a.status.includes(filter));

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">My Applications</h1>
          <p className="text-sm text-gray-500 mt-0.5">Track all your NOC applications</p>
        </div>
        <Link to="/user/apply" className="btn-primary text-sm">+ Apply New</Link>
      </div>

      {/* Filter Tabs */}
      <div className="flex gap-2 mb-4 flex-wrap">
        {[
          { key:'all', label:'All' },
          { key:'submitted', label:'Submitted' },
          { key:'approved', label:'Approved' },
          { key:'rejected', label:'Rejected' },
          { key:'objection', label:'Objection' },
          { key:'pulled', label:'Pulled' },
        ].map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${filter === f.key ? 'bg-blue-700 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:border-blue-300'}`}>
            {f.label}
          </button>
        ))}
      </div>

      {loading ? <LoadingSpinner size="lg" className="py-20" /> : (
        filtered.length === 0 ? (
          <EmptyState icon="📂" title="No Applications Found"
            desc="You haven't applied for any NOC yet."
            action={<Link to="/user/apply" className="btn-primary">Apply for NOC</Link>} />
        ) : (
          <div className="space-y-3">
            {filtered.map(app => (
              <Link key={app.id} to={`/user/applications/${app.id}`}
                className="card flex items-center justify-between hover:shadow-md hover:border-blue-200 border transition-all cursor-pointer group">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-2xl flex-shrink-0">📋</div>
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-semibold text-gray-800 group-hover:text-blue-700">{app.noc_name}</h3>
                      <StatusBadge status={app.status} />
                      {(app.status === 'objection_by_related' || app.status === 'objection_by_final') && (
                        <span className="text-xs bg-red-100 text-red-600 border border-red-200 px-2 py-0.5 rounded-full font-medium animate-pulse">
                          ⚠️ Action Required
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 mt-0.5">
                      {app.application_no} • {app.submitted_at ? format(new Date(app.submitted_at), 'dd MMM yyyy') : 'Draft'}
                    </p>
                    {app.current_dept && (
                      <p className="text-xs text-blue-600 mt-1">Currently at: {app.current_dept}</p>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  {app.status === 'approved_final' && (
                    <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">⬇️ Download</span>
                  )}
                  <span className="text-gray-300 group-hover:text-blue-400 text-xl">→</span>
                </div>
              </Link>
            ))}
          </div>
        )
      )}
    </div>
  );
}
